module.exports = __webpack_public_path__ + "static/assets/50ca829226bea12f7a4bb844bf090ee2.png";